import { blue, red } from '@ant-design/colors'
import styled from 'styled-components'
import TableWrapper from '../table-wrapper/table-wrapper'

const PrintQueueTableWrapper = styled(TableWrapper)`
    .print-job-cancelled td {
        background-color: ${red[1]};
    }

    .print-job-printing td {
        background-color: ${blue[1]};
    }

    .print-job-paused td {
        background-color: #fffbe6;
    }
`

export default PrintQueueTableWrapper
